<template>
  <div class="AllRegionPager">
    <app-header class="head-countryList" :title="$t('registerlogin.select_country')" @on-click="goBack"></app-header>
    <div class="main CountryMain">
        <van-field
              left-icon="search"
              clearable
              clear-trigger="always"
              class="van-search-country" 
              @touchstart="handleForceFocus('SearchInput')"
              ref="SearchInput" 
              v-model.trim="search" 
              :placeholder="$t('CountryGroup.placeholder')" 
          >
        </van-field>
      <van-index-bar :index-list="ursor" highlight-color="#323233">
        <!-- 搜索出来的 -->
        <div v-if="issearch">
          <van-cell @click="findviewByButton(v.iso2,v.countryName)"
            v-for="(v, k) in iscearchData"
            :key="k"
            :title="v.countryName" />
        </div>
        <div v-if="!issearch">
          <div v-if="isshowType == false">
            <div v-for="(values, key, index) in data" :key="index">
              <van-index-anchor :index="ursor[index]" />
              <div v-for="(v, k) in toLowerCaseData(data,ursor[index])" :key="k">
                <van-cell @click="findviewByButton(v.iso2, v.countryName)" v-if="v.isshow == true" :title="v.countryName" />
              </div>
            </div>
          </div>
          <div v-if="isshowType == true">
            <div v-for="(values, key) in JpData" :key="key">
              <van-index-anchor :index="ursor[key]" v-if="JpData[key]" />
              <div>
                <div v-for="(v, k) in JpData[key]" :key="k">
                  <van-cell @click="findviewByButton(v.iso2, v.countryName)" :title="v.countryName" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
import { Cell, IndexBar, IndexAnchor, Search, Tag } from "vant";
import CountryGroup from "../../../assets/country/country.js";
import cookie from "../../../utils/cookie";
export default {
  name: "RegisterCountry",
  components: {
    vanTag: Tag,
    vanCell: Cell,
    vanIndexBar: IndexBar,
    vanIndexAnchor: IndexAnchor,
    vanSearch: Search,
  },
  data() {
    return {
      issearch: false,
      iscearchData: [],
      search: "",
      getApiData: [],
      data: {},
      isshowType: false,
      ursor: [],
      country: [],
      iscounrty: [],
      gethisCountry: JSON.parse(localStorage.getItem("countryData")),
      getcolor: "",
      gethisCountryclick: true,
      JpData: [],
      iso2List:[],
    };
  },
  watch: {
    search(newName) {
      /**
       *监听 select的值 如果检索到了，那么先清空目前的值（newdata 组合后的值） 再将检索的值放到   this.isFilterData 过滤方法中
        否则当输入的值清空时将原始接口的值重新传入 this.isFilterData
       * **/
      if (newName.trim().length > 0) {
        this.gethisCountryclick = false;
        let datas = [];
        this.getApiData.forEach((element, i) => {
          if (element.countryName.toLowerCase().indexOf(newName.toLowerCase().trim()) != -1 && element.iso2 != "ALL") {
            datas.push(element);
          }
        });
        this.issearch = true;
        this.ursor = [];
        this.iscearchData = datas;
      } else if (newName === "") {
        this.gethisCountryclick = true;
        this.issearch = false;
        this.ursor = [];
        this.httpcountryGroup();
      }
    },
    // 离开页面清空搜索框
    $route() {
      this.value = "";
    },
  },
  mounted() {
    this.httpGetEnterpriseConfigList();
  },
  methods: {
    // 输入框获取焦点
    handleForceFocus(ref) {
      this.$refs[ref].focus();
    },
    goBack() {
      this.$emit('update:isShowCountry', false);
    },
    toLowerCaseData(data,key){
      if(!key) {
        return []
      }
      
      let lKey = key.toLowerCase()
      
      return this.data[lKey] || this.data[key]  || [];
    },
    //针对日文单独排序
    JPCountry(data) {
      let newdata = [];
      let unline = [];
      let CountryGroup_Country_JP_group = {};

      this.ursor = CountryGroup.Country_JP.title;
      if (data) {
        for (let T = 0; T < data.length; T++) {
          let element = data[T];
          for (let i = 0; i < CountryGroup.Country_JP.group.length; i++) {
            //初始化
            // newdata[i] =  [];
            //梳理数组Country_JP的当前group值
            CountryGroup.Country_JP.group[i].forEach((j, k) => {
              if (!CountryGroup_Country_JP_group[i]) CountryGroup_Country_JP_group[i] = {};

              if (j.indexOf(element.countryName.charAt(0)) > -1) {
                if (!CountryGroup_Country_JP_group[i][k]) CountryGroup_Country_JP_group[i][k] = [];
                CountryGroup_Country_JP_group[i][k].push(element);
                delete data[data.indexOf(element)];
              }
            });

            //梳理数组Country_JP的当前title项
            try {
              if (CountryGroup_Country_JP_group[i]) {
                let Current_I_values = Object.values(CountryGroup_Country_JP_group[i]).flat(Infinity);
                if (Current_I_values.length) {
                  newdata[i] = Current_I_values;
                } else {
                  //不处理
                }
              } else {
                //不处理
              }
            } catch (e) {
              //不赋值不处理
            }
          }
        }

        try {
          //#处理剩余值
          let Last_diff_data = data.flat(Infinity);
          // 去除全球
          Last_diff_data.forEach((element) => {
            if (element.iso2 == "ALL") {
              Last_diff_data.splice(element, 1);
            }
          });
          newdata[10] = Last_diff_data;
        } catch (e) {}

        if (newdata && newdata.length) {
          try {
            this.JpData = JSON.parse(JSON.stringify(newdata));
          } catch (e) {
            console.log(newdata);
          }
        }
      }
    },
    // 接口获取分站信息
    httpGetEnterpriseConfigList(){
        let enterpriseMap = {
          '/pl': 'EA00011095',
          '/ottocast': 'EA00011068'
        }
        let path = this.$route.path;
        this.$http
        .post({
          url: "/bss/app/noauth/queryEnterpriseConfigList",
          data: {
            partnerCode: "MAYA",
            enterpriseCode: this.$route.query.enterprisecode || enterpriseMap[path],
          },
          auth:false,
        })
        .then((res) => {
          if(res.data && res.data.length){
            res.data.forEach((item) => {
              if(item.iso2List && item.iso2List.length){
                this.iso2List = this.iso2List.concat(item.iso2List);
              }
            })
          }
          this.httpcountryGroup();
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    // 接口获取国家
    httpcountryGroup() {
      this.$http
        .post({
          url: "/bss/app/noauth/QueryCoverCountyInfo",
          data: {
            partnerCode: "MAYA",
            // coverFlag: "SHOW",
          },
          auth:false,
        })
        .then((res) => {
          if (res.data) {

            if(this.iso2List.includes('ALL')){
                this.getApiData = res.data;
            } else {
              this.getApiData = res.data.filter((item) => {
                return this.iso2List.includes(item.iso2)
              });
            }

            this.isshowType = false;
            if (cookie.get("langType") === "zh-CN") {
              this.countryGroup(this.getApiData, CountryGroup.Country_CN);
            } else if (cookie.get("langType") === "zh-TW") {
              this.countryGroup(this.getApiData, CountryGroup.Country_TW);
            } else if (cookie.get("langType") === "en-US") {
              this.countryGroup(this.getApiData, CountryGroup.Country_US);
            } else if (cookie.get("langType") === "ja-JP") {
              this.isshowType = true;
              this.JPCountry(this.getApiData);
            } else if (cookie.get("langType") === "tr-TR") {
              this.countryGroup(this.getApiData, CountryGroup.Country_TR);
            } else {
              this.countryGroup(this.getApiData, CountryGroup.Country_US);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast(err);
        });
    },
    countryGroup(val, countryLang) {
      let ordered = {};
      let getursor = [];
      Object.keys(countryLang)
        .sort()
        .forEach((key) => {
          ordered[key] = countryLang[key];
        });
      val.forEach((item) => {
        this.iscounrty.push(item.iso2);
      });

      for (let key in ordered) {
        this.ursor.push(key.toUpperCase());
        this.country.push(countryLang[key]);
        ordered[key].forEach((element) => {
          let country = val.find((item) => {
            return item.iso2 === element.iso2;
          });
          if (country?.countryName) {
            element.countryName = country?.countryName;
          }
        });
      }

      for (let i = 0; i < this.country.length; i++) {
        let K = 0; // 去除当首字母下没有匹配到数据 那么 吧首字母去掉
        let Q = 0;
        for (let j = 0; j < this.country[i].length; j++) {
          if (this.iscounrty.indexOf(this.country[i][j].iso2) == -1) {
            K = K + 1;
            this.country[i][j].isshow = false;
            if (this.country[i].length === K) {
              getursor.push(this.ursor[i]);
            }
          } else if (this.country[i][j].iso2 === "ALL") {
            // 去除全球
            Q = Q + 1;
            this.country[i][j].isshow = false;
            if (this.country[i].length === Q) {
              getursor.push(this.ursor[i]);
            }
          } else {
            this.country[i][j].isshow = true;
          }
        }
      }

      this.ursor = this.ursor.filter((item) => {
        return !getursor.includes(item);
      });
      
      this.data = ordered;
    },
    //点击国家
    findviewByButton(iso, name) {
      let a = {
          key: iso,
          value: name,
      };
      this.$emit("selectCountry", a);
      this.goBack();
    },
  },
};
</script>

<style scoped>
.head-countryList {
    position: fixed;
    left: 0;
    background-color: #f2f2f2;
    width: 100%;
    height: 48px;  
}
.CountryMain{
  position: relative;
  height: 100vh;
}
.CountryMain .van-index-anchor--sticky{
  position: relative;
  transform: none!important;
}
.JudgeRegionPager .van-search .van-field__control,.van-field__left-icon{
  padding: 0.12rem 0;
}
.gethisCountry .van-cell{
  padding:0 0.8rem 0 0.444444rem;
}
.main {
  background: #f2f2f2;
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  padding-top: 48px;
  padding-left: 10px;
  padding-right: 10px;
}
.tagbac {
  background: #fff;
  width: 100%;
  max-height: 110px;
  overflow: hidden;
}
.tagbac_tag {
  padding: 0.277778rem 0.444444rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.tagbac_tags {
  /* margin: 10px; */
  margin: 5px 5px 5px 0;
}
</style>

<style lang="less" scoped>
::v-deep {
  .van-cell::after {
      border-bottom: none;
  }
}
html[dir="rtl"] .AllRegionPager {
  .van-search-country {
    ::v-deep .van-field__control {
      text-align: right;
    }
  }
  ::v-deep {
    .van-field__left-icon {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .CountryMain {
    .van-cell {
      .van-cell__value {
        text-align: left;
      }
    }
    ::v-deep .van-index-bar {
      .van-index-bar__sidebar {
        right: unset;
        left: 0;
        .van-index-bar__index {
          padding-left: 8px;
        }
      }
    }
  }
}
</style>